import React from "react"
import { Button, OverlayTrigger, Popover } from "react-bootstrap"

import FilterObsSourceRadios from "./FilterObsSourceRadios"
import FilterSampleObsForm from "./FilterSampleObsForm"
import { isLTPM } from "../../../../../../components/shared_components_registration"
import { non_observation_graphs } from "../../../../resources/utils"

const registration = {
  data_label: (intl) =>
    isLTPM ? intl.formatMessage({ id: "general.data", defaultMessage: "Data" }) : "Data",
}

export default function FilterSampleObsPopover({
  sample_types = [],
  graphKey = {},
  plotConfigUpdater,
  index,
  updateGraph,
  intl,
}) {
  const title = (
    <div>
      <span className="fa fa-filter" />
      &nbsp;
      <span>{registration.data_label(intl)}</span>
    </div>
  )
  const showRadios = ![...["rnaseq"], ...non_observation_graphs].includes(graphKey.special)
  const showSampleForm =
    sample_types.length > 0 &&
    graphKey &&
    !graphKey.hideOffline &&
    (graphKey.observations || []).length > 0 &&
    !isLTPM

  const overlay = (
    <Popover id="filterSampleObs">
      <Popover.Header>{title}</Popover.Header>
      <Popover.Body>
        <>
          {graphKey && (
            <>
              {showRadios && (
                <FilterObsSourceRadios
                  updateGraph={updateGraph}
                  graphKey={graphKey}
                  index={index}
                  intl={intl}
                />
              )}
            </>
          )}
          {showSampleForm && (
            <>
              <hr />
              <FilterSampleObsForm
                sample_types={sample_types}
                graphKey={graphKey}
                plotConfigUpdater={plotConfigUpdater}
                intl={intl}
              />
            </>
          )}
        </>
      </Popover.Body>
    </Popover>
  )

  if (!(showSampleForm || showRadios)) return <></>

  return (
    <OverlayTrigger trigger={"click"} placement="bottom" rootClose overlay={overlay}>
      <Button
        variant={"outline-primary"}
        className={`btn btn-sm${
          graphKey.hideOnline || graphKey.hideOffline || graphKey.avgSampleData || graphKey.sampleTypes // Indicate that some type of filter or alteration has been applied
            ? " btn-selected"
            : ""
        }`}
      >
        {title}
      </Button>
    </OverlayTrigger>
  )
}
